import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onStartShareContactsAsVCard = action("onStartShareContactsAsVCard", event => ({
    event,
    owaType: "startShareContactsAsVCard",
})) as OwaNovaActionUnion<"startShareContactsAsVCard">;
